import React, { useState } from 'react';

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <style>
        {`
        
.pq-section.pq-style-1.text-center {
  text-align: center;
  margin-bottom: 40px;
}

.pq-section-sub-title {
  font-size: 18px;
  color: #666;
  display: block;
  margin-bottom: 10px;
}

.pq-section-title {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}


.pq-accordion-block {
  width: 100%;
}

.pq-accordion-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.pq-accordion-box.active {
  border-color: #239857;
}

.pq-ad-title {
  padding: 15px;
  background-color: #f9f9f9;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ad-title-text {
  font-size: 16px;
  color: #333;
  margin: 0;
  flex: 1;
}

.pq-accordion-details {
  padding: 0 15px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
}

.pq-accordion-details.open {
  padding: 15px;
  max-height: 500px; 
}

.pq-detail-text {
  font-size: 14px;
  color: #555;
  line-height: 1.6;
  margin: 0;
}

.fa {
  font-size: 14px;
  color: #239857;
  transition: transform 0.3s ease;
}

.fa-chevron-down {
  transform: rotate(0deg);
}

.fa-chevron-up {
  transform: rotate(180deg);
}
.pq-accordion-block .pq-accordion-box .pq-accordion-details {
  padding: 0 20px  !important;
  border: 1px solid var(--grey-color);
  border-top: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
`}
      </style>
      <section className="faq">
        <div className="container py-4">
          <div className="row">
             <div className="col-md-7">
            <div className="pq-section pq-style-1 text-center">
              <h2 className="pq-section-title">Frequently Asked Questions (FAQ’s)</h2>
            </div>
            
            <div className="col-xl-12 mt-xl-0 ps-xl-3">
              <div className="pq-accordion-block mt-4">
                {[ 
                  { question: "What is Otitis Externa (Swimmer’s Ear)?", answer: "Otitis Externa is an infection or inflammation of the outer ear canal, usually caused by moisture trapped in the ear, bacterial growth, or irritation from scratching or ear cleaning. It leads to pain, itching, swelling, and sometimes discharge. It’s a common and treatable condition." },
                  { question: "What are the common symptoms of Otitis Externa?", answer: "Typical symptoms include ear pain (often worse when touching the ear), itching, redness, swelling of the ear canal, watery or yellow discharge, blocked feeling, and temporary hearing loss. In severe cases, pain may spread to the jaw or side of the face." },
                  { question: "How is Otitis Externa diagnosed?", answer: "A doctor diagnoses Otitis Externa by examining the ear canal with an otoscope to check for swelling, redness, or discharge. They may ask about recent swimming, ear cleaning habits, or previous infections. Lab tests are rarely needed unless the infection is severe or recurrent." },
                  {question: "What is the treatment for Otitis Externa?", answer: "Treatment usually includes antibiotic ear drops, antifungal drops, or steroid drops to reduce inflammation. The doctor may clean the ear canal for better drop absorption. Pain relievers may be advised. Most patients feel relief within a few days and recover fully in 7–10 days."},
                  {question: "How can I prevent Otitis Externa?", answer: "Avoid inserting earbuds, cotton buds, or nails inside the ear. Keep ears dry after swimming or bathing by gently towel-drying them. Use earplugs while swimming if prone to infection. Never scratch the ear canal. If you feel moisture trapped inside, let it dry naturally."}
                ].map((item, index) => (
                  <div className={`pq-accordion-box ${activeIndex === index ? 'active' : ''}`} key={index}>
                    <div className="pq-ad-title" onClick={() => toggleAccordion(index)}>
                      <h4 className="ad-title-text">
                        {item.question}
                        <i className={`fa ${activeIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
                      </h4>
                    </div>
                    <div className={`pq-accordion-details ${activeIndex === index ? 'open' : ''}`}>
                      <p className="pq-detail-text">{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            </div>
              <div className="col-md-5 m-auto">
                  <div className="card shadow-lg">
                      <iframe width="100%" height="320" src="https://www.youtube.com/embed/VKx0Wa8S84s?si=1N2Q5qDg48UL4ZJi" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  <div class="p-3"><h5 class="text-success mb-0">Swimmer's Ear (Otitis Externa)|बाहरी कान का इंफेक्शन | Dr. Major Rajesh Bhardwaj </h5></div>
          </div>
              </div>
          </div>
        </div>
      </section>
    </div>
  );
}
